import React, { useContext } from 'react';
import { Paragraph, Skeleton, tokens } from '@welbe/web-design-system';
import {
	Container,
	MessageBox,
	EmployeeBox,
	BoxContainer,
} from './NameAndDescription.styles';
import { FiEdit } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { JobProfileContext } from 'Views/JobProfile/JobProfile.context';

type NameAndDescriptionType = {
	isLoading: boolean;
	name: string;
	description: string;
	employeesCount: number;
	handleEditProfile: () => void;
};

export const NameAndDescription = ({
	isLoading,
	name,
	description,
	employeesCount,
	handleEditProfile,
}: NameAndDescriptionType) => {
	const navigate = useNavigate();
	const { id, jobProfileType } = useContext(JobProfileContext);

	return (
		<Container>
			<Paragraph
				fontWeight="600"
				padding="0 0 20px 0"
				color={tokens.color_primary}
			>
				Nombre y descripción
			</Paragraph>
			{isLoading ? (
				<>
					<Skeleton height="95px" />
				</>
			) : (
				<BoxContainer>
					<MessageBox gray={!employeesCount}>
						<div>
							<Paragraph fontWeight="600" padding="0 0 15px 0" title={name}>
								{name}
							</Paragraph>
							<Paragraph elipsis title={description}>
								{description}
							</Paragraph>
						</div>
						<FiEdit
							color={tokens.color_primary}
							size={20}
							onClick={handleEditProfile}
						/>
					</MessageBox>
					{!!employeesCount && (
						<EmployeeBox>
							<div>
								<Paragraph>Colaboradores vinculados</Paragraph>
								<Paragraph fontWeight="600">{employeesCount}</Paragraph>
							</div>
							<a onClick={() => navigate(`/employees/${jobProfileType}/${id}`)}>
								<Paragraph
									color={tokens.color_primary_light}
									cursor="pointer"
									fontWeight="500"
									textDecoration="underline"
								>
									Ver colaboradores
								</Paragraph>
							</a>
						</EmployeeBox>
					)}
				</BoxContainer>
			)}
		</Container>
	);
};
